var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"siteUnitEvents-page && siteUnits.length > 0"},[(_vm.siteUnitEvents)?_c('SiteUnitEventsTable',{attrs:{"site-unit-events":_vm.siteUnitEvents}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }